<svelte:body on:item={put_item}/>
<script>
    import _ from 'lodash';
    import {validate_int} from '../../../validators.js';
    import {parameter, network} from '../../../stores.js';
    import {createEventDispatcher} from 'svelte';
    import {precision} from '../../../config.js';
    import {decode, encode} from '../../../helpers';
    import RalColor from "../../parts/RalColor.svelte";

    const dispatch = createEventDispatcher();
    const fixprecision = (value) => Math.ceil(value * precision) / precision;

    export let calc;
    export let options;

    export let put_item = async (e) => {
        let item = e.detail;

        if (item) {
            let fetched = await network.fetch_tovar(item.idTovar);
            let json = JSON.parse(decode(fetched.ind3));

            width.set(json.width);
            height.set(json.height);
            ind2 = json.ind2;
            ind3 = json.ind3;
            ind4 = json.ind4;
            ind5 = json.ind5;
            ind6 = json.ind6;
            ind7 = json.ind7;
            ind8 = json.ind8;

            fetchData = await fetch();
            count.set(+item.quantity);
            comment.set(item.comment);
            change();
        }
    };

    const color = options.color || {
        'Белый RAL 9016': 'Белый RAL 9016',
        'Кремовый RAL 1013': 'Кремовый RAL 1013',
        'Серый RAL 7040': 'Серый RAL 7040',
        'Коричневый RAL 8017': 'Коричневый RAL 8017',
        'Антрацит RAL 7016': 'Антрацит RAL 7016',
        'Черный RAL 9005': 'Черный RAL 9005',
        'Алюминиевый натуральный': 'Алюминиевый натуральный',
    };

    const SHTORKA_TYPES = [
        {type: 'ПЛИССЕ DARKOUT 90%', keyword: ['ПЛИССЕ DARKOUT 90%'.toLowerCase()]}, // --
        {type: 'ПЛИССЕ полупрозрачная 60%', keyword: ['ПЛИССЕ полупрозрачная 60%'.toLowerCase()]}, // --
        {type: 'СОТА BLACKOUT 16мм', keyword: ['СОТА BLACKOUT 16мм'.toLowerCase()]}, // --
        {type: 'СОТА BLACKOUT 20мм', keyword: ['СОТА BLACKOUT 20мм'.toLowerCase()]}, // --
        {type: 'СОТА полупрозрачная 16 мм', keyword: ['СОТА полупрозрачная 16 мм'.toLowerCase()]}, // --

    ];

    const UPAKOVKA_TYPES = [
        {keyword: 'картонный короб'},
        {keyword: 'пузырчатая пленка'},
        {keyword: 'стрейч пленка'},
    ];

    const MONTAJ_TYPES = [
        {type: 'Нет', keyword: null},
        {type: 'Пластиковые крепления', keyword: 'пластиковые крепления'},
        {type: 'Алюминиевый монтажный профиль', keyword: 'алюминиевый монтажный профиль'},
    ];

    function colorsFromKeyword(keyword, result) {
        return [...new Set(
            result
                .filter(i => i.name.toLowerCase().includes(keyword) && i.flag === '1')
                .map(i => i.ind2.trim())
                .filter(Boolean)
        )];
    }

    function availableKomplekt(result) {
        const l = colorsFromKeyword('комплектующие пластиковые', result);

        if (!l.includes(ind5)) ind5 = l[0];

        return l;
    }

    function availableNit(result) {
        const l = colorsFromKeyword('нить полиэстер', result);

        if (!l.includes(ind6)) ind6 = l[0];

        return l;
    }

    function availableUpakovka(result) {
        return result
            .filter(i => UPAKOVKA_TYPES.some(u => i.name.toLowerCase().includes(u.keyword)))
            .map(i => i.name.trim());
    }

    function availableMontaj(result) {
        return MONTAJ_TYPES.filter(({keyword}) =>
            keyword === null || result.some(i => i.name.toLowerCase().includes(keyword))
        ).map(m => m.type);
    }

    function availableShtorTypes(result) {
        if (!result) return [];

        const names = result.filter(i => i.flag === '1').map(i => i.name.toLowerCase());

        return SHTORKA_TYPES.filter(({keyword}) =>
            keyword.some(kw => names.some(n => n.includes(kw)))
        );
    }

    // Список цветов шторки в зависимости от вида
    function shtorkaColors(type, result) {
        if (!result) return [];
        const entry = SHTORKA_TYPES.find(t => t.type === type);
        if (!entry) return [];

        const l = [...new Set(
            result
                .filter(i => entry.keyword.some(kw => i.name.toLowerCase().includes(kw)) && i.flag === '1')
                .map(i => i.ind2.trim())
                .filter(Boolean)
        )]

        if (!l.includes(ind4)) ind4 = l[0];

        return l;
    }

    function shtorkaKeywordForCalc(type, colorValue, result) {
        const entry = SHTORKA_TYPES.find(t => t.type === type);
        if (!entry) return [];

        // Если у типа один keyword
        if (entry.keyword.length === 1) return entry.keyword;

        // Если несколько
        const matched = entry.keyword.filter(kw =>
            result.some(i =>
                i.name.toLowerCase().includes(kw) &&
                i.ind2.trim() === colorValue
            )
        );

        return matched.length ? matched : entry.keyword;
    }

    const fetch = async () => {
        let result = await network.fetch_data('Шторы-плиссе', '', '');
        let opts = await network.fetch_ind('Шторы-плиссе');

        return {
            name: _.groupBy(result, 'name'),
            ind1: _.groupBy(result, 'ind1'),
            ind2: _.groupBy(result, 'ind2'),
            ind3: _.groupBy(result, 'ind3'),
            edIzmer: _.groupBy(result, 'edIzmer'),
            options: opts,
            result,
        };
    };

    let
        width = parameter('width', '240'),
        height = parameter('height', '400'),
        ind2 = 'Белый RAL 9016',
        ind3 = 'ПЛИССЕ DARKOUT 90%',
        ind4 = 'Антрацит',
        ind5 = 'Белый',
        ind6 = 'Белый',
        ind7 = 'Стрейч пленка',
        ind8 = 'Нет',
        comment = parameter('comment', ''),
        count = parameter('count', 1)
    ;

    let fetchData = fetch();

    let
        montage_item,
        montage_price = 1;

    // расчёт стоимости
    const change = _.debounce(async () => {
        let data = await fetchData;
        let quantity = +$count,
            w = +$width,
            h = +$height;

        let result = {
            type: 'шторы-плиссе',
            name: 'Шторы плиссе',
            subname: [$width + 'x' + $height, ', ', ind2, ' - цвет профилей, ', ind3, ', ', ind4, ' - шторка, ', ind5, ' - комплектующие, ', ind6, ' - нить, ', ind7, ' - упаковка', ind8 !== 'Нет' ? ', ' + ind8 : ''].join(''),
            title: ['Шторы плиссе', ' ', $width + 'x' + $height, ', ', ind2, ' - цвет профилей, ', ind3, ', ', ind4, ' - шторка, ', ind5, ' - комплектующие, ', ind6, ' - нить, ', ind7, ' - упаковка', ind8 !== 'Нет' ? ', ' + ind8 : ''].join(''),
            params: {
                ind1: [ind5, ' - комплектующие, ', ind6, ' - нить, ', ind7, ' - упаковка'].join(''),
                ind2: ind2,
                ind3: encode(JSON.stringify({
                    width: $width,
                    height: $height,
                    ind2,
                    ind3,
                    ind4,
                    ind5,
                    ind6,
                    ind7,
                    ind8
                })),
                ind4: w,
                ind5: h,
            },
            price: {rozn: 0, opt: 0, sebest: 0},
            quantity,
            materials: {},
            comment: $comment,
            vStrukture: options.vStrukture || 104
        };

        _.forEach(data.result, function (item) {
            let name = item.name.toLowerCase();
            let price = {rozn: 0, opt: 0, sebest: 0};
            let kolvo = 0;

            if (name.includes('профиль') && name.includes(ind2.toLowerCase())) {
                kolvo = ((w - 10) * 2 / 1000).toFixed(3);
            }

            if (ind3 === 'Полупрозрачная' && name.includes('плиссированная шторка из полиэстера')) {
                if (item.ind2 === ind4) {
                    kolvo = ((w - 2) * h / 2.2 * 0.028 / 10000).toFixed(3);
                }
            } else {
                const shtorKeywords = shtorkaKeywordForCalc(ind3, ind4, data.result);

                if (item.ind2 === ind4 && shtorKeywords.some(kw => name.includes(kw))) {
                    kolvo = ((w / 1000) * h / 7.7 * 10 / 1000).toFixed(3);
                }
            }

            if (name.includes('нить') && name.includes(ind6.toLowerCase())) {
                kolvo = ((w * 4 + h * 2 + 300) * 2 / 1000).toFixed(3);
            }
            if (name.includes('вставка')) {
                kolvo = ((w - 4) * 2 / 1000).toFixed(3);
            }
            if (name.includes('комплектующие') && name.includes(ind5.toLowerCase())) {
                kolvo = (1).toFixed(3);
            }
            if (name.includes('заклепки')) {
                kolvo = (8).toFixed(3);
            }
            if (name.includes(ind7.toLowerCase())) {
                kolvo = 1;
            }
            if (name.includes('работа')) {
                kolvo = 1;
            }
            //['Нет', 'Пластиковые крепления', 'Алюминиевый монтажный профиль']
            if ((name.includes('ронштейн для монтажа') || name.includes('ластиковые крепления')) &&  ind8 =='Пластиковые крепления' ) {
                kolvo = 4;
            }
            if ((name.includes('люминиевый монтажный профиль')) &&  ind8 =='Алюминиевый монтажный профиль' ) {
                kolvo = ((w - 10) * 2 / 1000).toFixed(3);
            }

            if (kolvo) {
                price['rozn'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.price);
                price['opt'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.opt_price);
                price['sebest'] = fixprecision(kolvo * (1 + item.procentSpisania / 100) * item.sebestomost);

                result.materials[item.name] = {
                    order: +item.poryadok,
                    id: item.idTovar,
                    spis: item.procentSpisania,
                    type: item.edIzmer,
                    oprice: {
                        rozn: (+item.price).toFixed(2),
                        opt: (+item.opt_price).toFixed(2),
                        sebest: (+item.sebestomost).toFixed(2),
                    },
                    price,
                    quantity,
                    count: (+kolvo).toFixed(3)
                };
            }
            if (name.includes('монтаж')) {
                montage_item = item;
            }
        });

        result.price.rozn = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'rozn').toFixed(2);
        result.price.opt = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'opt').toFixed(2);
        result.price.sebest = _.sumBy(_.values(_.mapValues(result.materials, (o) => o.price)), 'sebest').toFixed(2);
        if (montage_item) {
            let mprice = Math.round((result.price.rozn / quantity) / 100 * montage_item.procentSpisania / 100) * 100;
            montage_price = +(montage_item.opt_price > mprice ? montage_item.opt_price * quantity : mprice * quantity).toFixed(2);
            dispatch('mounting', {item: montage_item, price: montage_price});
        }
        dispatch('item', result);
    }, 250);

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="parent">

            <div class="imgSystem justify-content-center align-content-center">
                <img style="max-height: 300px;" class="img-fluid p-3" src="/img/plisse/PlisseShtory.jpeg"
                     alt="Шторы плиссе"/>
            </div>

            {#if ($width > (options.recomend?.width ?? 6000) || $height > (options.recomend?.height ?? 6000))}
                <div class="info">
                    <span class="badge-danger text-white small rounded-2 text-center text-uppercase">
                        Изделие с данным размером не подлежит гарантии
                    </span>
                </div>
            {/if}

            <div class="width">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">200 ≥ Шир., мм ≥ {options.recomend?.width ?? 6000}</label>
                        <input type="number"
                               class="form-control text-center {$width > (options.recomend?.width ?? 6000) ? 'text-danger' : ''}"
                               step="10" min="200" max="{options.max?.width ?? 6000}"
                               bind:value={$width} use:validate_int={$width}>
                    </div>
                </div>
            </div>

            <div class="height">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">200 ≥ Выс., мм ≥ {options.recomend?.height ?? 3000}</label>
                        <input type="number"
                               class="form-control text-center {$height > (options.recomend?.height ?? 3000) ? 'text-danger' : ''}"
                               step="10" min="200" max="{options.max?.height ?? 3000}"
                               bind:value={$height} use:validate_int={$height}>
                    </div>
                </div>
            </div>

            <div class="colorProfile">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет профиля</label>
                        <select class="form-control form-select" bind:value={ind2}>
                            {#each Object.entries(color) as [value]}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="shtorType">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Вид шторы</label>
                        <select class="form-control form-select" bind:value={ind3} on:change={() => ind4 = shtorkaColors(ind3, data.result)[0]}>
                            {#each availableShtorTypes(data.result) as { type }}
                                <option value="{type}">{type}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="shtorColor">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет шторы</label>
                        <select class="form-control form-select" bind:value={ind4}>
                            {#each shtorkaColors(ind3, data.result) as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="komplektColor">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет комплектующих</label>
                        <select class="form-control form-select" bind:value={ind5}>
                            {#each availableKomplekt(data.result) as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="nitColor">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Цвет нити</label>
                        <select class="form-control form-select" bind:value={ind6}>
                            {#each availableNit(data.result) as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="upakovka">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Упаковка</label>
                        <select class="form-control form-select" bind:value={ind7}>
                            {#each availableUpakovka(data.result) as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="montaj">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Для монтажа</label>
                        <select class="form-control form-select" bind:value={ind8}>
                            {#each availableMontaj(data.result) as value}
                                <option value="{value}">{value}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="quantity">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Количество</label>
                        <input type="number" class="form-control" min="1" bind:value={$count} use:validate_int={count}>
                    </div>
                </div>
            </div>

            <div class="comment">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Примечание</label>
                        <textarea class="form-control" bind:value={$comment}></textarea>
                    </div>
                </div>
            </div>

            <div class="ralcolor">
                <RalColor color={ind2} bind:comment={$comment}/>
            </div>

        </div>
    </div>
{/await}

<style>
    .parent {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 5px;
        grid-row-gap: 0px;
        grid-template-areas:
            "info          info"
            "width         height"
            "colorProfile  colorProfile"
            "shtorType     shtorColor"
            "komplektColor nitColor"
            "upakovka      montaj"
            "quantity      quantity"
            "comment       comment"
            "ralcolor      ralcolor"
            "imgSystem     imgSystem"
    }

    @media (min-width: 575.98px) {
        .parent {
            grid-template-columns: repeat(3, 1fr);
            grid-template-areas:
                "imgSystem  info          info"
                "imgSystem  width         height"
                "imgSystem  colorProfile  colorProfile"
                "imgSystem  shtorType     shtorColor"
                "imgSystem  komplektColor nitColor"
                "imgSystem  upakovka      montaj"
                "quantity   quantity      quantity"
                "comment    comment       comment"
                "ralcolor   ralcolor      ralcolor"
        }
    }

    .imgSystem {
        grid-area: imgSystem;
    }

    .info {
        grid-area: info;
    }

    .width {
        grid-area: width;
    }

    .height {
        grid-area: height;
    }

    .colorProfile {
        grid-area: colorProfile;
    }

    .shtorType {
        grid-area: shtorType;
    }

    .shtorColor {
        grid-area: shtorColor;
    }

    .komplektColor {
        grid-area: komplektColor;
    }

    .nitColor {
        grid-area: nitColor;
    }

    .upakovka {
        grid-area: upakovka;
    }

    .montaj {
        grid-area: montaj;
    }

    .quantity {
        grid-area: quantity;
    }

    .comment {
        grid-area: comment;
    }

    .ralcolor {
        grid-area: ralcolor;
    }
</style>


